import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {TokenWithInvitation} from "../entities/token-with-invitation";

export interface TokensWithInvitationProps {
    tokens: TokenWithInvitation[];
    showAdminInfos: boolean;
}

export const TokensWithInvitation = ({tokens, showAdminInfos}: TokensWithInvitationProps) => {
    return (<TableContainer>
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Paid token ?</TableCell>
                    {showAdminInfos &&
                        <><TableCell>Update date</TableCell>
                            <TableCell>Updated by user</TableCell></>
                    }
                    <TableCell>Status</TableCell>
                    <TableCell>Invitee email</TableCell>
                    <TableCell>Course stream</TableCell>
                    <TableCell>End of Validity</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {tokens?.map((token) =>
                    <TableRow hover key={token.id}>
                        <TableCell>{token.id}</TableCell>
                        <TableCell>{token.isPaidToken ? "PAID" : "FREE"}</TableCell>
                        {showAdminInfos &&
                            <>
                                <TableCell>{new Date(token.lastModifiedAt).toLocaleString("fr-be")}</TableCell>
                                <TableCell>{token.lastModifiedBy}</TableCell>
                            </>}
                        <TableCell>{token.status}</TableCell>
                        {token.status !== 'AVAILABLE' && <>
                            <TableCell>{token.inviteeEmail}</TableCell>
                            <TableCell>{token.streamName}</TableCell>
                            <TableCell>{new Date(token.validityEndDate).toLocaleString("fr-be")}</TableCell>
                        </>}
                        {token.status === 'AVAILABLE' && <>
                            <TableCell>N/A</TableCell>
                            <TableCell>N/A</TableCell>
                            <TableCell>N/A</TableCell>
                        </>}
                    </TableRow>)}

            </TableBody>
        </Table>

    </TableContainer>)
}